module.exports = __webpack_public_path__ + "img/akkodis-logo.7622f382.svg";